var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useRef } from 'react';
import { SubmitButton } from '@/components/functional/Form/SubmitButton/SubmitButton';
import { AttachFileIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
export const FileInput = (props) => {
    const { accept, className = '', id, inputProps = {}, isFullRounded = false, name, onChange, size = 'sm' } = props, otherButtonProps = __rest(props, ["accept", "className", "id", "inputProps", "isFullRounded", "name", "onChange", "size"]);
    const fileInputRef = useRef(null);
    /**
     * ボタンクリック時
     */
    const onClickButton = useCallback(() => {
        var _a, _b;
        (_b = (_a = fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
        return false;
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({}, inputProps, { accept: accept, className: 'hidden', id: id, name: name, onChange: onChange, ref: fileInputRef, type: 'file' })), _jsx(SubmitButton, Object.assign({}, otherButtonProps, { className: clsx('min-w-[110px]', className), color: 'gray', isFullRounded: isFullRounded, onClick: onClickButton, size: size, type: 'button' }, { children: _jsxs("span", Object.assign({ className: 'flex items-center gap-4' }, { children: [_jsx(AttachFileIcon, { className: 'text-16', color: 'base', size: 'none' }), _jsx("span", { children: "\u30D5\u30A1\u30A4\u30EB\u9078\u629E" })] })) }))] }));
};
